import classNames from 'classnames';
import React, { use } from 'react';

import { getDefaultButtonClassName } from 'src/components/facilities/buttonCss';
import { SiteContext } from 'src/context/site-context';
import type { StaticTextLookupKey } from 'src/translators/static-text-lookup';
import { TranslatedStaticText } from 'src/translators/static-text-translator';

type WebsiteLinkButtonContentProps = {
  buttonText?: string | React.ReactElement | null;
  buttonKey?: StaticTextLookupKey;
  buttonClassName?: string;
  buttonEndIcon?: React.ReactElement;
  buttonType?: string;
  contentClassName?: string;
  gtmTrackingId?: string;
};

export const WebsiteLinkButtonContent: React.FC<WebsiteLinkButtonContentProps> = ({
  buttonText,
  buttonKey,
  buttonClassName,
  buttonEndIcon,
  buttonType,
  contentClassName,
  gtmTrackingId,
}) => {
  const { buildType } = use(SiteContext);

  return (
    <div
      className={classNames(
        buttonType ?? 'button-inline',
        contentClassName,
        buttonClassName ?? getDefaultButtonClassName(buildType)
      )}
      data-gtmid={gtmTrackingId || (typeof buttonText === 'string' ? buttonText : undefined)}
    >
      {buttonText || (buttonKey && <TranslatedStaticText lookupKey={buttonKey} />)}
      {buttonEndIcon}
    </div>
  );
};
